import { observable } from 'mobx';

export type CancelChargeElementResponseArgs = {
  id: number;
  content: string;
};

export type CancelChargeElementArgs = {
  id: number;
  content: string;
};

export const convertCancelChargeElementResponseToArgs = (response: CancelChargeElementResponseArgs) => {
  const args: CancelChargeElementArgs = {
    id: response.id,
    content: response.content
  };
  return args;
};

export default class CancelChargeElement {
  @observable
  id: number;

  @observable
  content: string;

  constructor(args: CancelChargeElementArgs) {
    this.id = args.id;
    this.content = args.content;
  }

  get type() {
    return 'cancel';
  }

  get title() {
    return 'キャンセル料';
  }

  get summary() {
    return this.content;
  }

  get name() {
    return this.title;
  }

  detail() {
    return '';
  }
}
